import React, { useState } from 'react';

function Header(props){
    const [current,setCurrent] = useState(props.s);
    const [sort, setSort] = useState(props.appSort);
    const def = 'none';
    return(
        <div className="p-4 h-25 w-100 text-white bg-dark mb-2">
            <h1 className="text-center display fw-bold">PIXA</h1>
            <div className="row row-cols-1 row-cols-md-2">
            <div className="col">
            <div className="input-group my-3">
                <input type="text" className="form-control" value={current} placeholder="yellow flowers" aria-label="Search" aria-describedby="basic-addon2" onInput={e =>setCurrent(e.target.value)} onKeyDown={e =>{if(e.key === 'Enter') props.searchFor(e.target.value)}}/>
                <div className="input-group-append">
                    <button className="btn btn-outline-info" type="button" onClick={()=>props.searchFor(current)}><i className="fa fa-search" aria-hidden="true"></i></button>
                </div>
            </div></div>
            <div className="col">
                <div className="input-group my-md-3 w-100">
                  <select className="form-control rounded w-lg-75" id="inputGroupSelect04" onChange={e=>setSort(e.target.value)} onKeyDown={e =>{if(e.key === 'Enter') props.sortApp(e.target.value)}} >
                    <option defaultValue={def}>Choose...</option>
                    <option value="tags">Name</option>
                    <option value="likes">Likes</option>
                    <option value="views">Views</option>
                  </select>
                  <div className="input-group-append w-lg-25">
                    <button className="btn btn-outline-info" type="button" onClick={() =>props.sortApp(sort)}>Sort By <i className="fa fa-sort-amount-asc" aria-hidden="true"></i>

</button>
                  </div>
                </div></div>
                </div>
        </div> 
    )
}

export default Header